export const REVIEW_QUEUE_KINDS = [
  'sitrep',
  'layer',
  'resource_request',
  'ics204',
  'task',
] as const;

export type ReviewQueueKind = (typeof REVIEW_QUEUE_KINDS)[number];

export type ReviewQueueItem = {
  kind: ReviewQueueKind;
  id: string;
  itemId: string | null;
  title: string;
  incidentId: string | null;
  incidentName: string | null;
  waitingOn: string;
  submittedBy: string | null;
  submittedAt: string | null;
  groupId: string | null;
};

export const REVIEW_QUEUE_KIND_LABELS: Record<ReviewQueueKind, string> = {
  sitrep: 'Report',
  layer: 'Map layer',
  resource_request: 'Resource request',
  ics204: 'ICS 204',
  task: 'Task',
};

export function reviewQueueOpenKey(item: Pick<ReviewQueueItem, 'kind' | 'id'>) {
  return `${item.kind}:${item.id}`;
}

export function parseReviewQueueOpen(
  value: string | null
): { kind: ReviewQueueKind; id: string } | null {
  if (!value) return null;
  const split = value.indexOf(':');
  if (split <= 0) return null;
  const kind = value.slice(0, split);
  const id = value.slice(split + 1);
  if (!id || !REVIEW_QUEUE_KINDS.includes(kind as ReviewQueueKind)) return null;
  return { kind: kind as ReviewQueueKind, id };
}
